/**
 * Order API Service
 * 
 * Handles all API calls related to orders
 */
import { apiService as api } from './api.service';

// API endpoints
const ENDPOINTS = {
  ORDERS: '/orders/summary',
  PO_DETAILS: (poNumber) => `/orders/PODetails/${poNumber}`,
  ORDERS_BY_RUN_ID: (runId) => `/orders/summary/${runId}`,
  ORDER_STATUS: (poNumber) => `/order-changes/${poNumber}/status`,
};

/**
 * Order API functions
 */
export const orderService = {
  getOrders: (params) => api.get(ENDPOINTS.ORDERS, { params }),
  
  // Purchase Order specific endpoints
  getPODetails: (poNumber) => api.get(ENDPOINTS.PO_DETAILS(poNumber)),
  
  // Get orders by optimization run ID
  getOrdersByRunId: (runId) => api.get(ENDPOINTS.ORDERS_BY_RUN_ID(runId)),
  
  // Update order status
  updateOrderStatus: (poNumber, status, userId = 'system', details = {}) => 
    api.put(
      ENDPOINTS.ORDER_STATUS(poNumber),
      {
        status,
        user_id: userId,
        details
      }
    ),
}; 